import { type FunctionComponent } from 'react';
import { useChannelStateContext } from 'stream-chat-react';
import { assert } from 'ts-essentials';
import { useTranslation } from '../../i18n/resources';
import styles from './ChannelHeader.module.css';

export const ChannelHeader: FunctionComponent = () => {
  const { t } = useTranslation();
  const { channel } = useChannelStateContext();
  const { members } = channel.state;
  const data = channel.data;
  assert(data);

  const online =
    Object.values(members).filter((member) => member.user?.online).length || 1;
  const name = data.name;
  assert(name);

  return (
    <div className={styles.root}>
      <div className={styles.channelTitle}>
        {t('prayerStream', 'channel_name_formatted', { name })}
      </div>
      <div className={styles.channelDetails}>
        <div className={styles.onlineStatus} />
        <div className={styles.memberOnlineCount}>
          {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Plural key
            t('prayerStream', 'members_online' as any, {
              count: online,
            })
          }
        </div>
      </div>
    </div>
  );
};
